<template>
  <div class="clientContent">
    <div class="clientForm">
      <el-form label-width="100px" :rules="rules" ref="clientFormRules" :model="clientInfo">
        <div style="display: flex; justify-content: space-between; background-color: #fff">
          <div class="flexStyle mainContent">
            <div class="imgStyle">
              <img :src="clientInfo.companyLogoKey" alt="" v-if="clientInfo.companyLogoKey" />
              <img :src="pro" alt="" v-else />
            </div>
            <div style="margin-left: 20px">
              <div class="flexStyle">
                <div class="flexStyleCloum">
                  <p style="color: #17757a; font-size: 21px; font-weight: 600">
                    {{ clientInfo.jobTitle
                    }}<span
                      v-if="
                        clientInfo.companyProvince ||
                        clientInfo.companyArea ||
                        clientInfo.companyCity
                      "
                      >-[<span v-if="clientInfo.companyProvince">{{
                        clientInfo.companyProvince
                      }}</span
                      ><span v-if="clientInfo.companyCity">-{{ clientInfo.companyCity }}</span
                      ><span v-if="clientInfo.companyArea">-{{ clientInfo.companyArea }}</span
                      >]</span
                    >
                  </p>
                  <p style="color: #333333; font-size: 19px; font-weight: 600; line-height: 25px">
                    {{ clientInfo.corporateName }}
                  </p>
                  <p style="color: #232323; font-size: 14px; line-height: 25px">
                    职能类型：{{ clientInfo.positionType }}
                  </p>
                  <p style="color: #232323; font-size: 14px; line-height: 25px">
                    学历要求：{{ clientInfo.educationalRequirements }}
                  </p>
                  <p class="salaryRange">
                    薪资范围：<span v-if="clientInfo.isAnnual">年薪</span><span v-else>月薪</span
                    ><span style="margin-left: 10px">{{ clientInfo.salaryRange }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; cursor: pointer; margin-right: 100px"
            @click="editItem"
          >
            <span style="color: #17757a; font-size: 15px">编辑</span
            ><dic-button icon="icon-jr-icon-modify" text="编辑" />
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="职位描述"></title-bar>

          <!-- <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="clientInfo.jobDescription"
            ></el-input> -->
          <p class="pStyle">{{ clientInfo.jobDescription }}</p>
          <title-bar title="所需技能"></title-bar>

          <!-- <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="clientInfo.requiredSkills"
            ></el-input> -->
          <p class="pStyle">{{ clientInfo.requiredSkills }}</p>
          <title-bar title="福利待遇"></title-bar>

          <!-- <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="clientInfo.fringeBenefits"
            ></el-input> -->
          <p class="pStyle">{{ clientInfo.fringeBenefits }}</p>
        </div>
      </el-form>
      <div class="business_details_foot">
        <p>来源：{{ clientInfo.source }}</p>
        <p>最近更新时间：{{ clientInfo.updateTime }}</p>
      </div>
    </div>
    <div class="buttonStyle">
      <el-button class="cancelButton" @click="cancel">返回</el-button>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
import pro from '../../../../../static/images/pro.png'
import DicButton from '@/components/DicButton.vue'
import { save, update, getpositionListByid } from '@/api/position.js'
import TitleBar from '../../../../components/TitleBar.vue'
export default {
  components: {
    DicButton,
    TitleBar
  },
  data() {
    return {
      pro,
      options: ['计算机', '自动化', '人工智能', '建筑', '房地产'],
      cilentNature: ['民企', '国企', '上市公司', '外企', '合资', '政府', '事业单位', '其他'],
      cilentScale: [
        '1-49人',
        '50-99人',
        '100-499人',
        '500-999人',
        '1000-2000人',
        '2000-5000人',
        '5000-10000人',
        '10000人以上'
      ],
      cilentState: ['未合作', '合作中', '待续约'],
      clientInfo: {
        companyLogo: '', //公司logo
        companyLogoKey: '', //公司logo
        corporateName: '', //公司名称
        companyCountry: '', //所在国家
        companyCity: '', //所在城市
        companyProvince: '', //所在省份
        educationalRequirements: '', //学历要求
        fringeBenefits: '', //福利待遇
        jobDescription: '', //职位描述
        jobTitle: '', //职位名称
        positionType: '', //职位类型
        requiredSkills: '', //所需技能
        salaryRange: '' //薪资范围
      },
      salary: [],
      rules: {
        jobTitle: [{ required: true, message: '请填写职位名称', trigger: 'onChange' }],
        corporateName: [{ required: true, message: '请填写公司名称', trigger: 'onChange' }],
        jobDescription: [{ required: true, message: '请填写职位描述', trigger: 'onChange' }],
        requiredSkills: [{ required: true, message: '请填写所需技能', trigger: 'onChange' }]
      }
    }
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    },
    clientType() {
      return this.$route.query.clientType
    },
    clientId() {
      return this.$route.query.id
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    if (this.clientType) {
      this.getpositionListByid()
    }
  },
  methods: {
    editItem() {
      this.$router.push({
        name: 'PositionMessage',
        query: {
          id: this.clientId,
          clientType: 1
        }
      })
    },
    // 单个查询
    async getpositionListByid() {
      const res = await getpositionListByid({ id: this.clientId })
      if (res.data.resultCode == 200) {
        this.clientInfo = res.data.data
        if (this.clientInfo.salaryRange) {
          this.salary = this.clientInfo.salaryRange.split('~')
        }
      }
    },
    //   添加联系人
    addprojectLeaderListAdd() {
      this.clientInfo.projectLeaderListAdd.push({
        contactInformation: '', //微信号
        projectLeader: '', //联系人姓名
        targetEnterprise: ''
      })
    },
    // 国家地区
    searchArae(val) {
      this.clientInfo.companyCountry = val.country

      this.clientInfo.companyProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.clientInfo.companyCity = val.city
      }
    },
    //   删除联系人
    removeprojectLeaderListAdd(index) {
      this.clientInfo.projectLeaderListAdd.splice(index, 1)
    },
    // 保存
    save() {
      this.$refs.clientFormRules.validate(async (valid) => {
        if (valid) {
          if (this.salary.length > 0) {
            this.clientInfo.salaryRange = this.salary.join('~')
          }
          let res
          if (this.clientType) {
            res = await update(this.clientInfo)
          } else {
            res = await save(this.clientInfo)
          }
          if (res.data.resultCode === 200) {
            if (this.clientType) {
              this.$message.success('修改成功')
            } else {
              this.$message.success('新增成功')
            }
            this.$router.go(-1)
          }
        }
      })
    },
    // 返回
    cancel() {
      this.$router.go(-1)
    },
    // 删除图片
    deleteImg() {
      ;(this.clientInfo.companyLogo = ''), (this.clientInfo.companyLogoKey = '')
    }
  }
}
</script>

<style scoped lang="less">
.mainContent {
  background-color: #fff;
  padding: 20px;
}
.flexStyle {
  display: flex;
  align-items: center;
}
.flexStyleCloum {
  display: flex;
  flex-direction: column;
}
.inputStyle {
  /deep/ .el-input {
    margin: 0 5px 5px 0;
  }
}
.buttonStyle {
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 100%;
  background-color: #fff;
  padding: 0 10px 20px 10px;
}
/deep/ .saveButton {
  background-color: #17757a !important;
  color: #fff;
  padding: 10px 30px;
}
/deep/ .cancelButton {
  border-color: #17757a !important;
  color: #17757a;
  padding: 10px 30px;
}
/deep/ .el-button:focus,
.el-button:hover {
  background-color: #fff;
}
.bottom {
  height: 20px;
}
.spanStyle {
  display: inline-block;
  padding: 0 10px;
  color: #17757a;
}
.dropDownBox {
  /deep/ .el-input__inner {
    width: 100%;
  }
  /deep/ .el-select {
    width: 100%;
  }
}
.formStyle {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
  /deep/ .el-form-item__label {
    display: block;
    width: 100% !important;
    text-align: left;
    color: #17757a;
    font-size: 15px;
    font-weight: 600;
  }
}
.imgStyle {
  text-align: center;
  /deep/ .el-button {
    padding: 5px 10px;
    border-color: #17757a;
    color: #17757a;
  }
}
img {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.business_details_foot {
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  padding-left: 20px;

  p {
    color: #999999;
    font-size: 12px;
    margin-top: 4px;
    line-height: 1.5em;
  }
}
.pStyle {
  border: 1px solid #999999;
  margin: 0 20px 20px 20px;
  padding: 5px;
  height: 200px;
  border-radius: 5px;
  text-indent: 2em;
  overflow: auto;
  font-size: 14px;
  color: #606266;
}
.salaryRange {
  color: #232323;
  font-size: 14px;
  line-height: 25px;
  span {
    display: inline-block;
    line-height: 25px;
  }
}
</style>
